import { useEffect, useState } from "react";
import { fetchBlog } from "@/lib/api";
import BlogCard from "@/components/rotta/BlogCard";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { fetchBlog().then(setPosts).catch(() => {}); }, []);

  return (
    <div data-testid="blog-page" className="pt-32 pb-24">
      <div className="container-rotta">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 text-[#C6A762] mb-5">
            <span className="gold-divider" />
            <span className="text-[11px] tracking-[0.35em] uppercase">Diário ROTTA</span>
          </div>
          <h1 className="font-display text-5xl md:text-6xl text-white leading-[1.0]">
            Histórias e dicas de <span className="text-gold-gradient">quem vive a estrada.</span>
          </h1>
          <p className="text-[#B8B8B8] mt-5 leading-relaxed">
            Artigos sobre rotas, equipamentos, destinos brasileiros, segurança e técnica para
            o mototurista exigente.
          </p>
        </div>

        <div className="mt-14 grid gap-7 md:grid-cols-2 lg:grid-cols-3">
          {posts.map((p) => <BlogCard key={p.slug} post={p} />)}
        </div>
      </div>
    </div>
  );
}
